import { Box, BoxProps } from 'reakit';
import cn from 'classnames';

const variants = {
  1: `text-3xl md:text-4xl lg:text-5xl`,
  2: `text-2xl md:text-3xl lg:text-4xl`,
  3: `text-xl md:text-2xl lg:text-3xl`,
  4: `text-lg md:text-xl lg:text-2xl`,
  5: `text-base md:text-lg lg:text-xl`,
};

const elements = {
  1: `h1`,
  2: `h2`,
  3: `h3`,
  4: `h4`,
  5: `h5`,
};

export type HeadingProps = {
  level?: 1 | 2 | 3 | 4 | 5;
  styleAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
} & BoxProps;

const keys = {
  h1: 1,
  h2: 2,
  h3: 3,
  h4: 4,
  h5: 5,
} as const;

export default function Heading({
  children,
  className,
  level = 1,
  styleAs,
  ...props
}: HeadingProps) {
  const as = elements[level] as React.ElementType;
  const styleVariant = styleAs ? keys[styleAs] : level;

  return (
    <Box
      as={as}
      className={cn(
        variants[styleVariant],
        `font-bold leading-snug`,
        className,
      )}
      {...props}
    >
      {children}
    </Box>
  );
}
